const Content = ({ children, menu }) => {
  return (
    <div className="flex">
      <div className="flex-none bg-sec-grey-2 lg:w-auto">{menu}</div>
      <div className="private-body">{children}</div>
    </div>
  )
}

export default Content
